import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useSaveAppointment() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((appointment) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = appointment.id
      ? quarkusApi.put('/appointments', appointment, authHeader)
      : quarkusApi.post('/appointments', appointment, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
